/**
 * Please note:
 *
 * Translations are provided as an illustration only and are
 * not guaranteed to be accurate or error-free.
 *
 * They are designed to show developers where to store their
 * chosen phrase or spelling variant in the target language.
 */

export const AG_CHARTS_LOCALE_SK_SK: Record<string, string> = {
    ariaAnnounceChart: 'graf, ${seriesCount}[number] sérií',
    ariaAnnounceFlowProportionLink: 'odkaz ${index} z ${count}, od ${from} do ${to}, ${sizeName} ${size}',
    ariaAnnounceFlowProportionNode: 'uzol ${index} z ${count}, ${description}',
    ariaAnnounceGaugeChart: 'stupnicový graf, ${caption}',
    ariaAnnounceHierarchyChart: 'hierarchický graf, ${caption}',
    ariaAnnounceHierarchyDatum: 'úroveň ${level}[number], ${count}[number] detí, ${description}',
    ariaAnnounceHoverDatum: '${datum}',
    ariaDescriptionLegendItem: 'Stlačením medzerníka alebo klávesy Enter prepnete viditeľnosť',
    ariaLabelAddHorizontalLine: 'Pridať vodorovnú čiaru',
    ariaLabelAnnotationOptionsToolbar: 'Možnosti anotácie',
    ariaLabelAnnotationSettingsDialog: 'Nastavenia anotácií',
    ariaLabelColorPicker: 'Výber farby',
    ariaLabelFinancialCharts: 'Finančné grafy',
    ariaLabelLegend: 'Legenda',
    ariaLabelLegendItem: '${label}, Položka legendy ${index}[number] z ${count}[number]',
    ariaLabelLegendItemUnknown: 'Neznáma položka legendy',
    ariaLabelLegendPageNext: 'Ďalšia strana legendy',
    ariaLabelLegendPagePrevious: 'Predchádzajúca stránka legendy',
    ariaLabelLegendPagination: 'Stránkovanie legendy',
    ariaLabelNavigator: 'Navigátor',
    ariaLabelNavigatorMaximum: 'Maximum',
    ariaLabelNavigatorMinimum: 'Minimálne',
    ariaLabelNavigatorRange: 'Rozsah',
    ariaLabelRangesToolbar: 'Rozsahy',
    ariaLabelSettingsTabBar: 'Nastavenia',
    ariaLabelZoomToolbar: 'Priblížiť',
    ariaValuePanRange: '${min}[percent0to2dp] do ${max}[percent0to2dp]',
    contextMenuDownload: 'Stiahnuť',
    contextMenuPanToCursor: 'Posunúť sem',
    contextMenuToggleOtherSeries: 'Prepnúť iné série',
    contextMenuToggleSeriesVisibility: 'Prepnúť viditeľnosť',
    contextMenuZoomToCursor: 'Priblížiť sem',
    dialogHeaderChannel: 'Kanál',
    dialogHeaderDatePriceRange: 'Dátum a cena',
    dialogHeaderDateRange: 'Rozsah dátumov',
    dialogHeaderFibonacciRange: 'Fib Oprava',
    dialogHeaderLine: 'Čiara',
    dialogHeaderPriceRange: 'Cenové rozpätie',
    dialogHeaderText: 'Text',
    dialogInputAlign: 'Zarovnať',
    dialogInputColorPicker: 'Farba',
    dialogInputColorPickerAltText: 'Farba textu',
    dialogInputExtendAbove: 'Rozšíriť nad',
    dialogInputExtendBelow: 'Rozšíriť nadol',
    dialogInputExtendChannelEnd: 'Rozšíriť koniec kanála',
    dialogInputExtendChannelStart: 'Predĺžiť začiatok kanála',
    dialogInputExtendLeft: 'Rozšíriť doľava',
    dialogInputExtendLineEnd: 'Predĺžiť koniec čiary',
    dialogInputExtendLineStart: 'Predĺžiť začiatok čiary',
    dialogInputExtendRight: 'Rozšíriť doprava',
    dialogInputFibonacciBands: 'Pásma',
    dialogInputFibonacciBandsAltText: 'Fibonacciho pásma',
    dialogInputFillColorPicker: 'Vyplniť',
    dialogInputFillColorPickerAltText: 'Farba výplne',
    dialogInputFontSize: 'Veľkosť',
    dialogInputFontSizeAltText: 'Veľkosť písma',
    dialogInputLineStyle: 'Čiarkovaný',
    dialogInputPosition: 'Pozícia',
    dialogInputReverse: 'Opačne',
    dialogInputShowFill: 'Zobraziť výplň',
    dialogInputStrokeWidth: 'Hrúbka čiary',
    dialogInputStrokeWidthAltText: 'Hrúbka línie',
    iconAltTextAlignCenter: 'Centrovať',
    iconAltTextAlignLeft: 'Vľavo',
    iconAltTextAlignRight: 'Vpravo',
    iconAltTextClose: 'Zavrieť',
    iconAltTextLineStyleDashed: 'Dlhé pomlčky',
    iconAltTextLineStyleDotted: 'Krátka pomlčka',
    iconAltTextLineStyleSolid: 'Plná',
    iconAltTextPositionBottom: 'Dno',
    iconAltTextPositionCenter: 'Stred',
    iconAltTextPositionTop: 'Horná',
    inputTextareaPlaceholder: 'Pridať text',
    measurerDateRangeBars: '${value}[number] pruhy',
    measurerPriceRangePercent: '${value}[percent]',
    measurerPriceRangeValue: '${value}[number]',
    measurerVolume: 'Objem ${value}',
    overlayLoadingData: 'Načítavam údaje...',
    overlayNoData: 'Žiadne údaje na zobrazenie',
    overlayNoVisibleSeries: 'Žiadna viditeľná séria',
    overlayUnsupportedBrowser: 'Nezlučiteľná verzia prehliadača. Prosím, aktualizujte si prehliadač.',
    seriesHistogramTooltipCount: '${yName} (počet)',
    seriesHistogramTooltipFrequency: 'Frekvencia',
    seriesHistogramTooltipMean: '${yName} (priemer)',
    seriesHistogramTooltipSum: '${yName} (súčet)',
    toolbarAnnotationsArrow: 'Šípka',
    toolbarAnnotationsArrowDown: 'Šípka dole',
    toolbarAnnotationsArrowUp: 'Šípka hore',
    toolbarAnnotationsCallout: 'Popis',
    toolbarAnnotationsClearAll: 'Vymazať všetko',
    toolbarAnnotationsComment: 'Komentár',
    toolbarAnnotationsDatePriceRange: 'Dátum a cena',
    toolbarAnnotationsDateRange: 'Časové obdobie',
    toolbarAnnotationsDelete: 'Vymazať',
    toolbarAnnotationsDisjointChannel: 'Nezávislý kanál',
    toolbarAnnotationsDragHandle: 'Ťahať panel nástrojov',
    toolbarAnnotationsFibonacciAnnotations: 'Fibonacci',
    toolbarAnnotationsFibonacciRetracement: 'Fib Retracement',
    toolbarAnnotationsFibonacciRetracementTrendBased: 'Fib Trend Based na základe trendu',
    toolbarAnnotationsFillColor: 'Farba výplne',
    toolbarAnnotationsHorizontalLine: 'Horizontálna čiara',
    toolbarAnnotationsLineAnnotations: 'Trendové čiary',
    toolbarAnnotationsLineColor: 'Farba čiary',
    toolbarAnnotationsLineStrokeWidth: 'Šírka čiarového ťahu',
    toolbarAnnotationsLineStyle: 'Štýl čiary',
    toolbarAnnotationsLock: 'Zamknúť',
    toolbarAnnotationsMeasurerAnnotations: 'Merania',
    toolbarAnnotationsNote: 'Poznámka',
    toolbarAnnotationsParallelChannel: 'Paralelný kanál',
    toolbarAnnotationsPriceRange: 'Cenový rozsah',
    toolbarAnnotationsQuickDatePriceRange: 'Zmerať',
    toolbarAnnotationsSettings: 'Nastavenia',
    toolbarAnnotationsShapeAnnotations: 'Šípky',
    toolbarAnnotationsText: 'Text',
    toolbarAnnotationsTextAnnotations: 'Textové anotácie',
    toolbarAnnotationsTextColor: 'Farba textu',
    toolbarAnnotationsTextSize: 'Veľkosť textu',
    toolbarAnnotationsTrendLine: 'Trendová čiara',
    toolbarAnnotationsUnlock: 'Odomknúť',
    toolbarAnnotationsVerticalLine: 'Zvislá čiara',
    toolbarRange1Month: '1M',
    toolbarRange1MonthAria: '1 mesiac',
    toolbarRange1Year: '1R',
    toolbarRange1YearAria: '1 rok',
    toolbarRange3Months: '3M',
    toolbarRange3MonthsAria: '3 mesiace',
    toolbarRange6Months: '6M',
    toolbarRange6MonthsAria: '6 mesiacov',
    toolbarRangeAll: 'Všetky',
    toolbarRangeAllAria: 'Všetko',
    toolbarRangeYearToDate: 'Od začiatku roka',
    toolbarRangeYearToDateAria: 'Rok do dnešného dňa',
    toolbarSeriesTypeCandles: 'Sviečky',
    toolbarSeriesTypeDropdown: 'Typ grafu',
    toolbarSeriesTypeHighLow: 'Vysoký Nízky',
    toolbarSeriesTypeHLC: 'HLC',
    toolbarSeriesTypeHollowCandles: 'Prázdne sviečky',
    toolbarSeriesTypeLine: 'Čiara',
    toolbarSeriesTypeLineWithMarkers: 'Čiara so značkami',
    toolbarSeriesTypeOHLC: 'OHLC',
    toolbarSeriesTypeStepLine: 'Schodiskový graf',
    toolbarZoomPanEnd: 'Posunúť na koniec',
    toolbarZoomPanLeft: 'Posunúť doľava',
    toolbarZoomPanRight: 'Posunúť doprava',
    toolbarZoomPanStart: 'Posun na začiatok',
    toolbarZoomReset: 'Obnoviť priblíženie',
    toolbarZoomZoomIn: 'Priblížiť',
    toolbarZoomZoomOut: 'Oddialiť',
    tooltipPaginationStatus: '${index}[number] z ${count}[number]',
};
